"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _commonHorizontalList = require("@mmc/common-horizontal-list");

var _legalTextBlock = require("@mmc/legal-text-block");

var _commonTabs = _interopRequireDefault(require("./common-tabs.css"));

var _baseTabs = _interopRequireDefault(require("./base-tabs"));

var instanceId = 0;

var CommonTabs = /*#__PURE__*/function (_BaseTabs) {
  (0, _inheritsLoose2["default"])(CommonTabs, _BaseTabs);

  CommonTabs.resourceType = function resourceType() {
    return 'CommonTabs';
  };

  function CommonTabs(props) {
    var _this;

    _this = _BaseTabs.call(this, props) || this;
    _this.state = {
      selectedTab: props.selectedTab
    };
    _this.tabs = props.tabNames.map(function () {
      return /*#__PURE__*/_react["default"].createRef();
    });
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKey = _this.handleKey.bind((0, _assertThisInitialized2["default"])(_this));
    instanceId += 1;
    _this.instanceId = instanceId;
    return _this;
  }

  var _proto = CommonTabs.prototype;

  _proto.render = function render() {
    var _clsx,
        _this2 = this;

    var selectedTab = this.state.selectedTab;
    var _this$props = this.props,
        tabNames = _this$props.tabNames,
        children = _this$props.children,
        fullWidth = _this$props.fullWidth,
        theme = _this$props.theme,
        tabListClasses = _this$props.tabListClasses,
        disabledTabs = _this$props.disabledTabs,
        showSelectMenuIfScrollable = _this$props.showSelectMenuIfScrollable,
        showSelectMenuAllBreakpoints = _this$props.showSelectMenuAllBreakpoints,
        variant = _this$props.variant,
        selectName = _this$props.selectName,
        ctaWrapperClasses = _this$props.ctaWrapperClasses,
        disclaimerData = _this$props.disclaimerData,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? String(this.instanceId) : _this$props$id;
    var isDarkVariant = variant === 'dark';
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(_commonTabs["default"].tabNamesContainer, (_clsx = {}, _clsx[_commonTabs["default"].dark] = isDarkVariant, _clsx[_commonTabs["default"].fullWidth] = fullWidth, _clsx)),
      role: "navigation",
      "data-tabcount": tabNames ? tabNames.length : 0
    }, /*#__PURE__*/_react["default"].createElement(_commonHorizontalList.CommonHorizontalList, {
      showSelectMenuIfScrollable: showSelectMenuIfScrollable,
      showSelectMenuAllBreakpoints: showSelectMenuAllBreakpoints,
      items: tabNames,
      onItemClick: this.handleClick,
      activeIndex: selectedTab,
      onKeyDown: this.handleKey,
      ariaControlsId: id,
      tabClasses: this.getTabClasses(),
      ctaWrapperClasses: ctaWrapperClasses,
      classes: this.getHorizontalListClasses(),
      tabListClasses: tabListClasses,
      selectName: selectName,
      disabledTabs: disabledTabs,
      theme: theme
    })), children.map(function (tabContent, index) {
      var _clsx2;

      return /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-next-line react/no-array-index-key
        key: id + "_tab" + index,
        id: id + "_tab" + index,
        className: (0, _clsx3["default"])(_commonTabs["default"].tab, (_clsx2 = {}, _clsx2[_commonTabs["default"][variant + "Content"]] = true, _clsx2[_commonTabs["default"].active] = _this2.isTabActive(index), _clsx2))
      }, tabContent);
    }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, disclaimerData && Array.isArray(disclaimerData.disclaimerList) && /*#__PURE__*/_react["default"].createElement(_legalTextBlock.LegalTextBlock, {
      data: {
        disclaimerLabel: disclaimerData.disclaimerLabel,
        useAccordion: true,
        disclaimerList: disclaimerData.disclaimerList
      },
      theme: theme
    })));
  };

  return CommonTabs;
}(_baseTabs["default"]);

exports["default"] = CommonTabs;
CommonTabs.displayName = 'CommonTabs';
CommonTabs.propTypes = _baseTabs["default"].propTypes;
CommonTabs.defaultProps = _baseTabs["default"].defaultProps;